export const SET_USERS = "USERS_SET_USERS";
export const SET_PAGE = "USERS_SET_PAGE";
export const SEARCH_CHANGE = "USERS_SEARCH_CHANGE";
